import { Outlet, useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useCurrentUserQuery, UserRole } from 'entities/user';
import { Routes } from 'shared/routes';
import Loader from 'shared/ui/Loader';

const AdminEvaluationsAccessLayout = () => {
  const { data: currentUser, isLoading } = useCurrentUserQuery();
  const router = useRouter();

  useEffect(() => {
    if (!isLoading && currentUser && currentUser.role !== UserRole.Admin) {
      router.navigate({ to: Routes.frontend.adminPath });
    }
  }, [currentUser, isLoading, router]);

  if (isLoading || !currentUser) {
    return <Loader />;
  }

  if (currentUser.role !== UserRole.Admin) {
    return <Loader />;
  }

  return <Outlet />;
};

export { AdminEvaluationsAccessLayout };
